import cx from 'classnames';
import Message from '../Message/index.js';

interface InfoDisplayProps {
  classNames?: string;
  id?: string;
  message: string | JSX.Element;
  visible: boolean;
}

export default function InfoDisplay({
  id,
  message,
  visible,
  classNames,
}: InfoDisplayProps): JSX.Element {
  return (
    // Adding absolute position help escape this element from parent flex calculations when not visible
    <div aria-live="polite" className={cx(!visible && 'absolute', classNames)}>
      {visible && (
        <Message variant="info" id={id}>
          {message}
        </Message>
      )}
    </div>
  );
}
